export const HOMEPAGE_SECTIONS_LIMIT = 4;
export const DEFAULT_ITEMS_LIMIT = 10;
